import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Callout, CommandBarButton, DefaultButton, DirectionalHint, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { ApplicationState } from '../../store';
import { DelegationScope, actionCreators, getActingAs } from '../../store/DelegationStore';
import { PersonFromListPickerInput } from '../common/inputs/PersonFromListPickerInput';
import { PersonInfo } from '../common/inputs/PersonPickerInput';

type OwnProps = {
    scope: DelegationScope;
};

type StateProps = {
    actingAs?: PersonInfo;
};

type ActionProps = {
    stopDelegationMode: typeof actionCreators.stopDelegationMode;
};

type Props = OwnProps & StateProps & ActionProps;

const DelegationModeBannerComponent = (props: Props) => {
    if (!props.actingAs) {
        return null;
    }

    return (
        <div className="delegation-mode-banner">
            <MessageBar
                messageBarType={MessageBarType.warning}
                isMultiline={false}
                actions={
                    <DefaultButton
                        text="Stop Delegation Mode"
                        onClick={() => props.stopDelegationMode(props.scope)} />
                }>
                <span className="half-bold-font">Delegation Mode</span>: Viewing{" "}
                <span className="half-bold-font">{props.actingAs.fullName}</span>'s Approval Center. Your actions will
                be applied on their behalf.
            </MessageBar>
        </div>
    );
};

export const DelegationModeBanner = connect(
    (state: ApplicationState, ownProps: OwnProps): StateProps => ({
        actingAs: getActingAs(state, ownProps.scope)
    }),
    (dispatch: Dispatch): ActionProps =>
        bindActionCreators({ stopDelegationMode: actionCreators.stopDelegationMode }, dispatch)
)(DelegationModeBannerComponent);

type StartDelegationModeButtonProps = {
    candidates: PersonInfo[];
    onStart: (delegator: PersonInfo) => void;
};

export const StartDelegationModeButton = (props: StartDelegationModeButtonProps) => {
    const button = React.useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isPositioned, setIsPositioned] = React.useState(false);

    const close = () => {
        setIsOpen(false);
        setIsPositioned(false);
    };

    return <>
        <CommandBarButton
            componentRef={_ => button.current = (_ as any)?._buttonElement?.current}
            text="Start Delegation Mode"
            iconProps={{ iconName: "PeopleRepeat" }}
            menuIconProps={{ iconName: "ChevronDown" }}
            onClick={() => isOpen ? close() : setIsOpen(true)} />
        {isOpen && <Callout
            target={button.current}
            calloutWidth={300}
            isBeakVisible={false}
            gapSpace={5}
            directionalHint={DirectionalHint.bottomLeftEdge}
            directionalHintForRTL={DirectionalHint.bottomRightEdge}
            onPositioned={() => setIsPositioned(true)}
            onDismiss={close}>
            <div style={{ padding: 10 }}>
                {isPositioned && <PersonFromListPickerInput
                    users={props.candidates}
                    autoExpand
                    inputProps={{ autoFocus: true, placeholder: "Type to search" }}
                    onChanged={value => {
                        const delegator = value as PersonInfo | undefined;
                        if (delegator) {
                            close();
                            props.onStart(delegator);
                        }
                    }} />}
            </div>
        </Callout>}
    </>;
};
